<script setup></script>

<template>
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="2" width="12" height="12" rx="6" />
    <path d="M5.5 8H11.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.5 11L8.5 5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<style scoped lang="scss"></style>
